import { ActionIcon, Card, Group, Text } from '@mantine/core';
import {
	ConversationItemCommentFragment,
	useArchiveConversationItemCommentMutation,
} from 'generated/graphql';
import PersonAvatar, {
	PersonAvatarSize,
} from 'packages/kakapo-ui-kit/components/users/PersonAvatar';
import moment from 'moment';
import TrashIcon from 'packages/kakapo-ui-kit/assets/icons/TrashIcon';
import { QuillText } from '@treams/treams-ui';

export default function Comment({ comment }: { comment: ConversationItemCommentFragment }) {
	const [archiveConversationItemCommentMutation, { loading: archiving }] =
		useArchiveConversationItemCommentMutation();

	const handleArchive = async () => {
		await archiveConversationItemCommentMutation({
			variables: {
				commentID: comment.id,
			},
			update(cache, { data }) {
				if (data?.archiveConversationItemComment) {
					const id = cache.identify(comment);

					cache.evict({ id });
					cache.gc();
				}
			},
		});
	};

	return (
		<Card p="xs">
			<Group gap="8px">
				<PersonAvatar person={comment.participant.user} size={PersonAvatarSize.Small} />{' '}
				<div style={{ flexGrow: 1 }}>
					<Text size="sm" style={{ flexGrow: 1 }}>
						{comment.participant.user.firstName} {comment.participant.user.lastName}
					</Text>
					<Text size="xs" c="dimmed">
						{moment(comment.createdAt).fromNow()}
					</Text>
				</div>
				{comment.viewerCanArchive && (
					<ActionIcon
						size="md"
						variant="subtle"
						radius="xl"
						color="dimmed"
						loading={archiving}
						onClick={handleArchive}
					>
						<TrashIcon />
					</ActionIcon>
				)}
			</Group>
			<Text size="md" mt="4px">
				<QuillText value={comment.content} />
			</Text>
		</Card>
	);
}
